import styled from "styled-components";

export const Nav = styled.div`
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.0975);
`;

export const NavHeader = styled.div`
  display: flex;
  min-width: 100vw;
  min-height: 50px;
  max-width: 1010px;
  padding: 0px 0px;
  width: 100%;
  align-items: center;
  margin: 0 auto;
`;

export const NavLeft = styled.div`
  width: 33.333%;
  text-align: left;
  padding-left: 5rem;
`;

export const NavCenter = styled.div`
  width: 33.333%;
  text-align: center;
`;

export const NavRight = styled.div`
  width: 33.333%;
  display: flex;
  justify-content: flex-end;
  padding-right: 1rem;
`;

export const MenuLink = styled.a``;
